import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { FiPageCollapsableContentComponent } from './fi-page-collapsable-content.component';
import { FiPageCollapsableContentTitleComponent } from './fi-page-collapsable-content-title.component';
import { FiPageCollapsableContentSubtitleComponent } from './fi-page-collapsable-content-subtitle.component';

@NgModule({
    imports: [CommonModule, FiRollupContentModule],
    declarations: [
        FiPageCollapsableContentComponent,
        FiPageCollapsableContentTitleComponent,
        FiPageCollapsableContentSubtitleComponent,
    ],
    exports: [
        FiPageCollapsableContentComponent,
        FiPageCollapsableContentTitleComponent,
        FiPageCollapsableContentSubtitleComponent,
    ],
})
export class FiPageCollapsableContentModule {}
